<template>
  <v-dialog
    class="modal-avatar"
    v-model="modalAvatar"
    width="500"
    persistent
  >
    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title>
        <v-icon class="mr-2">mdi-camera mdi-24px</v-icon>
        <h4 class="headline">Escolha uma foto</h4>
      </v-card-title>

      <v-card-text>
        <v-layout justify-center>
          <v-avatar
            class="avatar-preview"
            size="240"
            color="grey lighten-4"
          >
            <img v-if="photo" :src="photo" width="64" alt="Avatar" />
            <v-icon size="64" v-else>mdi-image-outline</v-icon>
          </v-avatar>
        </v-layout>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-layout v-if="!photo" justify-center="">
          <v-spacer />
          <v-btn flat @click="cancel">Cancelar</v-btn>

          <v-spacer />

          <div class="picture-uploader-container">
            <button class="v-btn accent">
              Escolher Foto
            </button>
            <input
              @change="uploadImage"
              type="file"
              name="uploader"
              accept="image/*"
              class="picture-uploader"
            />
          </div>

          <v-spacer />
        </v-layout>

        <v-layout v-if="photo" justify-center>
          <v-spacer />
          <v-btn
            flat
            color="primary"
            @click="restartData">
            Não gostei
          </v-btn>

          <v-spacer />

          <v-btn
            flat
            color="success"
            @click="updateAvatar"
            :loading="loading.show"
          >
            Gostei
          </v-btn>
          <v-spacer />
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

const reader = new FileReader();

export default {
  name: 'ModalAvatar',
  data() {
    return {
      camera: null,
      deviceId: null,
      devices: [],
      photo: null,
    };
  },
  computed: {
    modalAvatar() {
      return this.$store.getters.modalAvatar;
    },
    userId() {
      return this.$store.getters.user.id;
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
  methods: {
    toggleModalAvatar(value) {
      this.$store.dispatch('toggleModalAvatar', value);
    },
    cancel() {
      this.toggleModalAvatar(false);
      this.restartData();
    },
    uploadImage(event) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        file = e.target.result;
        this.photo = file;
      };
    },
    restartData() {
      this.photo = null;
    },
    updateAvatar() {
      this.$store.dispatch('updateUser', { userId: this.userId, avatar: this.photo });
      this.toggleModalAvatar(false);
      this.restartData();
    },
  },
};
</script>

<style scoped lang="scss">
// .modal-avatar {}
// .avatar-preview {
//   overflow: hidden;
// }

// .avatar-camera {
//   position: relative;
//   width: 100%;
//   height: 100%;

//   video {
//     position: absolute;
//     left: 50%;
//     top: 50%;
//     transform: translate(-50%, -50%);
//   }
// }
.picture-uploader-container {
  position: relative;
  overflow: hidden;
  display: inline-block;
}
.picture-uploader {
  cursor: pointer;
  position: absolute;
  height: 36px;
  opacity: 0;
  left: -51px;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/account/avatar/ModalAvatar.vue